export default __webpack_public_path__ + "static/media/lock_open.07a5ed6d.svg";